import oracleAiVectorSearchProfessional2025 from '../Assets/img/oracle-ai-vector-search-professional-2025.png';
import oracleCloudInfrastructureAiFoundationsAssociate2025 from '../Assets/img/oracle-cloud-infrastructure-ai-foundations-associate-2025.png';
import oracleApexCloudDeveloperProfessional from '../Assets/img/oracle-apex-cloud-developer-professional.png';

const Certifications = [
  {
    id: 'oracle-ai-vector-search-professional-2025',
    title: 'Oracle AI Vector Search Professional',
    credential: 'Oracle Certified Professional',
    year: '2025',
    track: 'AI',
    issuer: 'Oracle',
    badgeSrc: oracleAiVectorSearchProfessional2025,
  },
  {
    id: 'oracle-cloud-infrastructure-ai-foundations-associate-2025',
    title: 'Oracle Cloud Infrastructure AI Foundations Associate',
    credential: 'Oracle Certified Foundations Associate',
    year: '2025',
    track: 'AI',
    issuer: 'Oracle',
    badgeSrc: oracleCloudInfrastructureAiFoundationsAssociate2025,
  },
  {
    id: 'oracle-apex-cloud-developer-professional',
    title: 'Oracle APEX Cloud Developer Professional',
    credential: 'Oracle Certified Professional',
    year: '2025',
    track: 'APEX',
    issuer: 'Oracle',
    badgeSrc: oracleApexCloudDeveloperProfessional,
  },
];

export default Certifications;
